"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.assign.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = require("@evdy/web-core/dist/components/shared/Input");

require("./ModalInput.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/***
 * returns an Input component wrapped in RRF Form component
 * @param {Object} argsObject
 * @param {string} props.formModel forms.commentForm
 * @param {fn} props.handleFormSubmit handleSubmit drilled down
 * @param {string} props.inputModel .commentText
 * @param {string} props.rows : rows text area can expand to before scrolling
 * @returns {component} Form from rrf wrapped in Input
 */
var ModalInput = function ModalInput(_ref) {
  var formModel = _ref.formModel,
      _ref$handleFormSubmit = _ref.handleFormSubmit,
      handleFormSubmit = _ref$handleFormSubmit === void 0 ? function () {} : _ref$handleFormSubmit,
      inputModel = _ref.inputModel,
      isValid = _ref.isValid;
  // enable disabled form submits if isValid is defined
  var submitOpts = {
    disabled: isValid && !isValid
  };
  return /*#__PURE__*/_react.default.createElement(_Input.Form, {
    model: formModel,
    onSubmit: handleFormSubmit,
    className: "modal-2020-input"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "input-container"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    model: inputModel,
    type: "textarea",
    validators: {
      isRequired: _Input.isRequired
    },
    placeholder: "Write a comment..."
  }), /*#__PURE__*/_react.default.createElement("button", _extends({}, submitOpts, {
    type: "submit"
  }), "Post")));
};

var string = _propTypes.default.string,
    func = _propTypes.default.func,
    bool = _propTypes.default.bool;
ModalInput.propTypes = {
  formModel: string.isRequired,
  handleFormSubmit: func,
  inputModel: string.isRequired,
  isValid: bool.isRequired
};
var _default = ModalInput;
exports.default = _default;